// extracted by mini-css-extract-plugin
export default {"body_page":"App_body_page__-IXaX","sidebar":"App_sidebar__D0dyD"};